export const SettingDisplayTypes = {
  TEXT: "text",
  SENSITIVE: "sensitive",
  DEALERSETTINGGROUPBOOLEAN: "dealersettinggroupboolean"
};

export const MAX_SETTING_LENGTH = 128;
